var styles = {
  "KeyboardNavigationOption": "Online-Store-UI-KeyboardNavigationOption_azdsx",
  "selected": "Online-Store-UI-KeyboardNavigationOption--selected_bg3sx",
  "cover": "Online-Store-UI-KeyboardNavigationOption--cover_ninnw"
};

export { styles as default };
